import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { Centerlink } from "../../shared/centerlink.model";
import { CenterlinkService } from "../../shared/centerlink.service";

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-centrelinklist',
  templateUrl: './centrelinklist.component.html',
  styleUrls: ['./centrelinklist.component.css']
})
export class CentrelinklistComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'CentreName', 'GroupName', 'CustomerName', 'AdmissionFee', 'New'];

  LoanApprovedStatus: Number = 0;
  toast : Toastpayload;

  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private centerlinkService: CenterlinkService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,
    ) { }

  ngOnInit() {
    
    this.GetCentreLinkList();
    this.dataSource.paginator = this.paginator;
  }

//   ngAfterViewInit() {
//     // this.GetCentreLinkList();
//     // this.dataSource.paginator = this.paginator;
// }

  GetCentreLinkList() {

    this.centerlinkService.GetCentreLinkList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  Add() {
    this.router.navigate(['/centerlink']);
  }

  Edit(loan: any) {
    this.router.navigate(['/centerlink', loan.Id]);
  }

  // centre delete action
  IUDCentreLink(element: any){

    this.centerlinkService.selectedCenterlink = new Centerlink;

          this.centerlinkService.selectedCenterlink.Id = element.Id;
          this.centerlinkService.selectedCenterlink.CentreId = element.CentreId;
          this.centerlinkService.selectedCenterlink.CustomerId = element.CustomerId;
          this.centerlinkService.selectedCenterlink.Flag = 3; // deactivate
          // IUD action
          this.centerlinkService.IUDCentreLink(this.centerlinkService.selectedCenterlink)
            .toPromise()
            .then(data => {
              this.router.navigate(['/centrelinklist']);
              // showing message:
              this.toasterserviceService.showToast(this.toast);
            })
  }

  Delete(element: any) {

    this.toast = {
      message: "Beneficiery centre have been deleted",
      title: 'Centre link deletion', 
      ic:  {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',    
    };

    // 'error'
    // this.confirmationdialogService.confirm('Please confirm..', 'Do you really want to ... ?')
    // .then((confirmed) => console.log('User confirmed:', confirmed))
    // .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));

    let title: string = "Confirmation";
    let message: string ="If you continue, beneficiery assigned to the centre will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let  btnCancelText: string = 'No, Exit';
    
    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
          // centrelink deletion
          this.IUDCentreLink(element); 
        }
        else{

          // console.log(confirmed);
          this.toast.message = 'You are cancelled the beneficiery centre deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
